export enum HistoryPeriodType {
  Date = 0,
  Week = 1,
  Month = 2,
}